import api from './http';

export const fetchLandingContent = async () => {
  try {
    const res = await api.get('/api/landing-content');
    return res.data;
  } catch (error) {
    console.error('Failed to fetch landing content:', error);
    return { success: false, error };
  }
};

